import React from 'react';
import { TextField, useRecordContext } from 'react-admin';
import { get } from 'lodash';
import conflictFields from '../../../../constants/conflictFields';
import Answer from '../Answer';
import merchantCategoryCode, { MerchantCategoryCode as MerchantCategoryCodeType } from '../../../../constants/merchantCategoryCode';
import { MerchantCategoryCodeParameters } from '../../questionParameters';
import { Languages } from '../../../../constants/languages';

const ValueField = ({
  extraParameters,
}: {
  extraParameters?: MerchantCategoryCodeParameters;
  language?: Languages;
}) => {
  const record = useRecordContext<{
    value: MerchantCategoryCodeType;
    sx?: any;
  }>();

  if (!record) return null;

  const sx = get(record, 'sx', {});
  const value = get(record, 'value', '');
  const label = extraParameters?.choiceLabels?.[value]
    ?? `${value} - ${merchantCategoryCode[value as MerchantCategoryCodeType]}`;

  return <TextField record={{ value: label }} sx={sx} source="value" emptyText="-" fontWeight="bold" />;
};

const MerchantCategoryCode = ({
  extraParameters,
}: {
  extraParameters?: MerchantCategoryCodeParameters;
}) => (
  <Answer
    label={extraParameters?.label ?? extraParameters?.inputLabel ?? 'Merchant Category Code (MCC)'}
    source="merchantCategoryCode"
    datapoint={conflictFields.MERCHANT_CATEGORY_CODE}
    identificationInfo={undefined}
  >
    <ValueField extraParameters={extraParameters} />
  </Answer>
);

MerchantCategoryCode.ValueField = ValueField;

export default MerchantCategoryCode;
